var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-content",style:({ backgroundColor: _vm.bgColor, color: _vm.color })},[_c('div',{staticClass:"seytm_text"},[_vm._v(" "+_vm._s(_vm.data)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }